import * as Yup from 'yup';

export const validationSchemaEmissionCalculator = Yup.object({
	flights: Yup.array()
		.of(
			Yup.object({
				origin: Yup.object({
					id: Yup.string().required('Origin is required'),
				})
					.required('Origin is required')
					.nullable(),
				destination: Yup.object({
					id: Yup.string().required('Destination is required'),
				})
					.required('Destination is required')
					.nullable(),
			}),
		)
		.required(),
	bookingClass: Yup.string().required('Please choose a booking class'),
});
